import AdLightningReporting from './ad_lightning_reporting';
import AmazonBidding from './amazon_bidding';
import ATS from './ats';
import BlockthroughSetup from './blockthrough_setup';
import ConcertId from './concert_id';
import ConcertCrescendoControl from './concert_crescendo_control';
import ConcertTracking from './concert_tracking';
import ConcertExperiments from './concert_experiments';
import Permutive from './permutive';
import PrebidBidding from './prebid_bidding';
import RubiconDemandManagerBidding from './rubicon_demand_manager_bidding';
import DoubleVerifyTargeting from './double_verify';
import ScrollVelocity from './scroll_velocity';
import OneTrustIntegration from './onetrust_integration';
import OptimeraCommon from './optimera_common';
import OptimeraMeasurement from './optimera_measurement';
import GooglePair from './google_pair';
import HighlightMode from './highlight_mode';
import DynamicPlugins from './dynamic';

export default [
  AdLightningReporting,
  AmazonBidding,
  ATS,
  BlockthroughSetup,
  ConcertId,
  ConcertCrescendoControl,
  ConcertTracking,
  ConcertExperiments,
  Permutive,
  PrebidBidding,
  RubiconDemandManagerBidding,
  DoubleVerifyTargeting,
  ScrollVelocity,
  OneTrustIntegration,
  OptimeraCommon,
  OptimeraMeasurement,
  GooglePair,
  HighlightMode,
  DynamicPlugins,
];
